<template lang="pug">
    v-app-bar.header.pt-1(fixed)
        v-container.py-0
            v-row(no-gutters)
                v-col.col-2.col-md-4
                    logo-component

                v-col.col-10.col-md-8
                    nav.text-right.align-center
                        navigation-component(
                            v-for="(item, key) in menu"
                            :key="`navigation-button-${key}`"
                            :to="item.to"
                            :text="item.title"
                            :isLink="item.isLink"
                        )

                        v-btn.hidden-xs-only(
                            outlined
                            v-if="dashboard"
                            @click="unlogin"
                            small
                            color="white"
                        )
                            span Logout
                            v-icon arrow_forward
</template>

<script>
    import VueTypes from 'vue-types';
    import Navigation from '../Navigation';
    import Logo from '../Logo';
    import { mapActions } from 'vuex';

    export default {
        components: {
            NavigationComponent: Navigation,
            LogoComponent: Logo,
        },
        props: {
            menu: VueTypes.array.def([]),
            dashboard: VueTypes.bool.def(false),
        },
        methods: {
            ...mapActions('auth', ['logout']),
            unlogin() {
                this.logout();
            },
        },
    };
</script>

<style lang="stylus" scoped>
    @import "../../assets/style/_variables.styl"

    .header
        background: $gradient

    >>> .v-toolbar__content
        padding: 0
</style>
